import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { UserService } from "src/app/shared/services/rnapi2-service/apis/user.service";
import { RnUserIsEmailUnique } from "../../../services/rnapi2-service/models/models";
import { ConstantsService } from "../../../services/constants/constants.service";
import { ToasterService, ToastType } from "@rn-platform/frontend-shared-data-access-toaster";

@Component({
    selector: "app-email-verfication",
    templateUrl: "./email-verfication.component.html",
    styleUrls: ["./email-verfication.component.scss"],
    standalone: false
})
export class EmailVerficationComponent {
  private userService = inject(UserService);
  private toasterService = inject(ToasterService);
  private constantsService = inject(ConstantsService);

  @Input() userDetailsForm = new FormGroup({});
  @Input() showStaticEmail = false;
  @Input() inEditingMode = false;
  @Input() userProfile;
  @Input() emailLabel = "Email Address";
  @Input() location = "addUser";
  @Input() profileId: string;
  @Input() showIcon = false;
  @Input() hideLeftPadding = false;
  @Input() labelClass = "";
  @Input() emailInputClass = "";
  @Output() pendingValidationEvent = new EventEmitter<boolean>();
  @Output() emailUnique = new EventEmitter<boolean>();
  public rnUserIsEmailUnique: RnUserIsEmailUnique;

  public pendingvalidation = false;
  public nonspecific = false;

  onBlurEmail() {
    if (this.email.value !== "" && this.email.valid) {
      // need to trim the value here, since the appTrimInput directive doesn't always execute before this function does
      this.rnUserIsEmailUnique = {
        search: this.email.value?.trim(),
        checkAD: true,
      };
      if (this.profileId && this.profileId != "")
        this.rnUserIsEmailUnique.Id = this.profileId;
      this.pendingvalidation = true;
      this.pendingValidationEvent.emit(true);
      this.emailUnique.emit(false);
      this.userService
        .apiV2UsersIsemailuniquePost(this.rnUserIsEmailUnique)
        .subscribe({ next: (response) => {
          this.nonspecific = !response.data;
          this.pendingvalidation = false;
          this.pendingValidationEvent.emit(false);
          this.emailUnique.emit(response.data);
          if (this.nonspecific) {
            this.email.setErrors({
              nonspecific: true,
            });
          }
        },
          error: (error) => {
            console.error(error);
            if (error.error.Messages && error.error.Messages[0].Code == this.constantsService.emailMergeError) {
              this.pendingvalidation = false;
              this.pendingValidationEvent.emit(false);
              this.nonspecific = true;
              this.email.setErrors({
                mergeerror: true,
              });
            const message =
              'The e-mail address provided is associated with multiple accounts. Please contact Support for further assistance.';
            const id = 'apphub-email-verfication-merge-error-toast';
            this.toasterService.addToast(ToastType.Error_, message, message, id, id);
            }
        }
      });
    }
  }
  get email() {
    return this.userDetailsForm.controls["email"];
  }
}
